module.exports = __webpack_public_path__ + "static/media/instructions.441003f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/instructions.jpg
// module id = 587
// module chunks = 0